import type { CSSProperties } from 'react';
import './QuizAnswerButton.css';

export type QuizAnswerButtonState = 'default' | 'correct' | 'incorrect';

export type QuizAnswerButtonProps = {
  label: string;
  top: number;
  onClick?: () => void;
  state?: QuizAnswerButtonState;
  disabled?: boolean;
};

/** Figma quiz answer (161:23939+) — bevel CTA with text label. */
export function QuizAnswerButton({
  label,
  top,
  onClick,
  state = 'default',
  disabled = false,
}: QuizAnswerButtonProps) {
  const style = {
    '--quiz-answer-top': `${top}px`,
  } as CSSProperties;

  const className = [
    'quiz-answer-button',
    'quiz-content-enter',
    state !== 'default' ? `quiz-answer-button--${state}` : null,
    disabled ? 'quiz-answer-button--disabled' : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={className}
      style={style}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="quiz-answer-button__label quiz-outlined-text">{label}</span>
    </button>
  );
}
